import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_child_info_page = _resolveComponent("child-info-page")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.child)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.child.lastName) + " " + _toDisplayString(_ctx.child.firstName) + " の保護者情報 ", 1))
        : _createCommentVNode("", true),
      _createVNode(_component_v_spacer)
    ]),
    _createElementVNode("div", null, [
      (_ctx.isSaving || _ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "primary",
            class: "my-8"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_divider, { class: "my-4" }),
    _createElementVNode("div", _hoisted_3, [
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "primary--text" }, "保護者情報", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        "x-large": "",
        variant: "flat",
        color: "primary",
        onClick: _ctx.save,
        disabled: _ctx.isSaving
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("保存", -1)
        ]))]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parentInfo, (p) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "my-4",
        key: p.parent.key
      }, [
        _createElementVNode("h2", null, _toDisplayString(p.parent.lastName) + " " + _toDisplayString(p.parent.firstName), 1),
        _createVNode(_component_child_info_page, {
          elements: p.parentInfo,
          onInput: ($event: any) => (_ctx.updateInfo($event, p))
        }, null, 8, ["elements", "onInput"]),
        _createVNode(_component_v_divider, { class: "my-4" })
      ]))
    }), 128))
  ]))
}